module.exports = __webpack_public_path__ + "files/c220e89731c31367c0f4e86e3442bee0.png";


//////////////////
// WEBPACK FOOTER
// ./images/favicon/favicon-32x32.png
// module id = 1208
// module chunks = 60